import '@/utils/rem'

import Vue from 'vue'
import App from './App.vue'
import { createPinia, PiniaVuePlugin } from 'pinia'

// 引入elemet-ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import plugins from './plugins'
// 文件下载
import { download } from '@/utils/request'

import router from "./router";
import Pagination from "@/components/Pagination"
import VueMenu from "@/components/VueMenu"

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.prototype.download = download

Vue.component('Pagination', Pagination)
Vue.component('VueMenu', VueMenu)

Vue.use(ElementUI)
Vue.use(plugins)
Vue.config.productionTip = false
Vue.use(PiniaVuePlugin)

const pinia = createPinia()

new Vue({
  pinia,
  router,
  render: h => h(App),
}).$mount('#app')

